import { render, staticRenderFns } from "./AddServe.vue?vue&type=template&id=2d8e4df7&scoped=true&"
import script from "./AddServe.vue?vue&type=script&lang=js&"
export * from "./AddServe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e4df7",
  null
  
)

export default component.exports